module.exports = __webpack_public_path__ + "media/video_compressed_muted_480p.ed1dbd39.webm";